import { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router';

const Debug = lazy(() => import('./Debug'));

const DEBUG_ROUTES: RouteObject[] = [
  {
    path: 'debug',
    element: (
      <Suspense fallback={null}>
        <Debug />
      </Suspense>
    )
  }
];

export default DEBUG_ROUTES;
